import { z } from "zod";
export const BookingResultSchema = z.object({
    bookingId: z.string(),
    status: z.string(),
    expiresAt: z.string(),
    paymentDelivery: z.string(),
});
